import { GATEWAY_PASS_NOT_ALLOWED_REASON } from 'src/features/eventLog/types';

export enum DISPLAY_ACTION {
    SUCCESSFUL_ENTRANCE = 'successful_entrance',
    REJECTED_ENTRANCE = 'rejected_entrance',
    SUCCESSFUL_EXIT = 'successful_exit',
    REJECTED_EXIT = 'rejected_exit',
    EXIT_PAYMENT_DUE_AMOUNT = 'exit_payment_due_amount',
    EXIT_PAYMENT_INSERT_CARD = 'exit_payment_insert_card',
    EXIT_PAYMENT_CARD_ACCEPTED = 'exit_payment_card_accepted',
    EXIT_PAYMENT_CARD_REJECTED = 'exit_payment_card_rejected',
    EXIT_PAYMENT_PIN_REQUESTED = 'exit_payment_pin_requested',
    EXIT_PAYMENT_PROCESSING = 'exit_payment_processing',
    EXIT_PAYMENT_CONFIRMED = 'exit_payment_confirmed',
    EXIT_PAYMENT_FAILED = 'exit_payment_failed',
}

export enum DISPLAY_IDLE_ACTION {
    DATE = 'date',
    SPACES = 'spaces',
    LPR = 'lpr',
    TICKET = 'ticket',
    CARD = 'card',
}

export type SimulateGatewayPass = {
    gateway_pass_successful: boolean;
    status_code: number | null;
    default_code: string | null;
    default_message: string | null;
    reason: GATEWAY_PASS_NOT_ALLOWED_REASON | null;
};
